/**
 * Organisation endpoints (bos-api API-185).
 *
 * Relative to the axios client's base, which already ends in `/api/v1` — so
 * `/organizations/me` reaches `…/api/v1/organizations/me`.
 *
 * Every path is `me`: a token names exactly one organisation, and the API has
 * no route that reads or writes another one. See `CONTRACT.md`.
 */

export const OrganizationsEndpoints = {
    /** GET — the caller's organisation and its onboarding state. */
    me: () => '/organizations/me',
    /** POST (no body) — marks the organisation onboarded. OrgAdmin. */
    finishOnboarding: () => '/organizations/me/onboarding/finish',
    /** POST `{ year }` — generates the fiscal year and its tax rates. OrgAdmin. */
    accountingStart: () => '/organizations/me/onboarding/accounting-start',
};
